import React, { useEffect, useState } from "react";
import "./Patron_Portfolio.css";
import Patron_Navbar from "../../Patron_Navbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { makeAuthenticatedGETRequest } from "../../../services/serverHelper";
import { patronProfilePoints } from "../../../services/apis";
import { useSelector } from "react-redux";
import { BsCheckLg } from "react-icons/bs";
import { 
  AiOutlineMail, 
  AiOutlinePhone, 
  AiOutlineGlobal, 
  AiOutlineEnvironment,
  AiOutlineEdit
} from "react-icons/ai";
import { MdBusinessCenter, MdPerson } from "react-icons/md";
import PatronSidebar from "../../PatronSidebar";
import profileImg from "../assets/profileImg.svg";


export default function Patron_Portfolio() {
  const [patronAvatar, setPatronAvatar] = useState("");
  const navigate = useNavigate();
  const { accessToken } = useSelector((state) => state.auth);
  const [avatarSrc, setAvatarSrc] = useState('');
  const [formData, setFormData] = useState({
    personalInfo: {
      profession: "",
      companyName: "",
      authorizedPerson: "",
      designation: "",
      companyDescription: "",
      firstName: "",
      lastName: "",
    },
    address: {
      state: "",
      city: "",
      pincode: "",
      details: "",
    },
    contactDetails: {
      email: "",
      contactNumber: "",
      website: "",
      expectations: "",
    },
  });

  const fetchPatronData = async () => {
    const toastId = toast.loading("Loading...");
    try {
      const response = await makeAuthenticatedGETRequest(
        `${patronProfilePoints.FETCH_PATRON_APPLI_API}/${localStorage.getItem("artId")}`,
        accessToken
      );
      console.log(response);
      if (response.status === "success") {
        setFormData(response.data);
        setAvatarSrc(response.data.personalInfo?.avatar?.url || profileImg);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("internal server error, please try again");
    }
    toast.dismiss(toastId);
  };

  useEffect(() => {
    fetchPatronData();
  }, []);

  const getFullImageUrl = (imageValue) => {
    if (!imageValue) return "/default-avatar.png";

    try {
      let raw = String(imageValue).replace(/[\u0000-\u001F\u007F]+/g, "").trim();
      if (!raw) return "/default-avatar.png";

      // blob URL (local preview)
      if (raw.startsWith("blob:")) return raw;

      // If string contains absolute URL anywhere (sometimes backend returns weird concatenation), extract first http(s)
      const absMatch = raw.match(/https?:\/\/[^\s]+/i);
      if (absMatch && absMatch[0]) {
        // return absolute URL directly (preserve)
        return absMatch[0];
      }

      // protocol-relative
      if (raw.startsWith("//")) return "https:" + raw;

      // strip leading slashes and common prefixes
      let cleaned = raw
        .replace(/^\/+/, "")
        .replace(/^public\/images\//i, "")
        .replace(/^public\/uploads\//i, "")
        .replace(/^uploads\/performance\//i, "")
        .replace(/^uploads\//i, "")
        .replace(/^images\//i, "")
        .replace(/^api\/v1\/images\//i, "")
        .replace(/^api\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/api\/v1\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/uploads\/performance\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\//i, "")
        .trim();

      // Build host from env or default
      const envBase = process.env.REACT_APP_BASE_URL || "https://api.ekalakaar.com";
      // Ensure we keep only host (strip any /api/v1 etc)
      let API_HOST = String(envBase).replace(/\/api(\/v?1)?(\/.*)?$/i, "").replace(/\/+$/i, "");
      if (!API_HOST.startsWith("http")) {
        API_HOST = "https://" + API_HOST;
      }

      // Use /images/<filename> endpoint which your backend serves
      return `${API_HOST}/images/${cleaned}`;
    } catch (err) {
      console.error("getFullImageUrl error:", err, imageValue);
      return "/default-avatar.png";
    }
  };

  return (
    <>
      <Patron_Navbar />
      <div className="dashboard-layout">
        <PatronSidebar />
        <div className="modern_patron_portfolio_page">
          <div className="modern_portfolio_container">
            
            {/* Hero Card */}
            <div className="modern_hero_card">
              <div className="modern_hero_gradient">
                <div className="modern_hero_pattern"></div>
                <div className="modern_hero_content">
                  
                  {/* Avatar Section */}
                  <div className="modern_avatar_section">
                    <div className="modern_avatar_wrapper">
                      <img
                        loading="lazy"
                          src={getFullImageUrl(avatarSrc || "")}
                          alt="Profile avatar"
                          onError={(e) => {
                            console.error("Avatar load failed:", e.target.src);
                            try {
                              // try fallback: construct from original value
                              const fallback = getFullImageUrl(avatarSrc || "");
                              if (fallback && fallback !== e.target.src) {
                                e.target.onerror = null;
                                e.target.src = fallback;
                                return;
                              }
                              // try decode %40 -> @ fallback
                              if (e.target.src.includes("%40")) {
                                e.target.onerror = null;
                                e.target.src = e.target.src.replace(/%40/g, "@");
                                return;
                              }
                            } catch (err) {
                              console.warn("avatar fallback error", err);
                            }
                            e.target.onerror = null;
                            e.target.src = "/default-avatar.png";
                          }}
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          objectFit: "cover",
                          // transform removed from here
                        }}
                      />
                      <div className="modern_verified_badge">
                        <BsCheckLg className="modern_verified_icon" />
                      </div>
                    </div>
                  </div>

                  {/* Info Section */}
                  <div className="modern_info_section">
                    <h1 className="modern_patron_name">
                      {formData?.personalInfo?.firstName} {formData?.personalInfo?.lastName}
                    </h1>
                    <div className="modern_badges_wrapper">
                      <span className="modern_badge">
                        <MdBusinessCenter className="modern_badge_icon" />
                        {formData?.personalInfo?.companyName}
                      </span>
                      <span className="modern_badge">
                        <MdPerson className="modern_badge_icon" />
                        {formData?.personalInfo?.profession}
                      </span>
                    </div>

                    {/* Contact Info */}
                    <div className="modern_contact_quick">
                      <a href={`tel:${parseInt(formData?.contactDetails?.contactNumber)}`} className="modern_contact_item">
                        <AiOutlinePhone className="modern_contact_icon" />
                        <span>{parseInt(formData?.contactDetails?.contactNumber)}</span>
                      </a>
                      <a href={`mailto:${formData?.contactDetails?.email}`} className="modern_contact_item">
                        <AiOutlineMail className="modern_contact_icon" />
                        <span>{formData?.contactDetails?.email}</span>
                      </a>
                      <div className="modern_contact_item">
                        <AiOutlineEnvironment className="modern_contact_icon" />
                        <span>{formData?.address?.city}, {formData?.address?.state}</span>
                      </div>
                    </div>
                  </div>

                  {/* Logo Section */}
                  {/* <div className="modern_logo_section">
                    <div className="modern_logo_box">
                      <img 
                        src="assets/HomePage/eK_Logo_Trasnparent_1.png"
                        alt="eKalakaar Logo"
                        className="modern_ek_logo"
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Content Grid */}
            <div className="modern_content_grid">
              
              {/* Main Content */}
              <div className="modern_main_content">
                
                {/* About Section */}
                <div className="modern_card">
                  <h2 className="modern_card_title">
                    <div className="modern_title_accent"></div>
                    About the Company
                  </h2>
                  <p className="modern_card_text">
                    {formData?.personalInfo?.companyDescription || "No company description available."}
                  </p>
                </div>

                {/* Professional Details */}
                <div className="modern_card">
                  <h2 className="modern_card_title">
                    <div className="modern_title_accent"></div>
                    Professional Details
                  </h2>
                  <div className="modern_details_grid">
                    <div className="modern_detail_item">
                      <label className="modern_detail_label">First Name</label>
                      <p className="modern_detail_value">{formData?.personalInfo?.firstName}</p>
                    </div>
                    <div className="modern_detail_item">
                      <label className="modern_detail_label">Last Name</label>
                      <p className="modern_detail_value">{formData?.personalInfo?.lastName}</p>
                    </div>
                    <div className="modern_detail_item">
                      <label className="modern_detail_label">Profession</label>
                      <p className="modern_detail_value">{formData?.personalInfo?.profession}</p>
                    </div>
                    <div className="modern_detail_item">
                      <label className="modern_detail_label">Company Name</label>
                      <p className="modern_detail_value">{formData?.personalInfo?.companyName}</p>
                    </div>
                    <div className="modern_detail_item">
                      <label className="modern_detail_label">Authorized Person</label>
                      <p className="modern_detail_value">{formData?.personalInfo?.authorizedPerson}</p>
                    </div>
                    <div className="modern_detail_item">
                      <label className="modern_detail_label">Designation</label>
                      <p className="modern_detail_value">{formData?.personalInfo?.designation}</p>
                    </div>
                  </div>
                </div>

                {/* Expectations */}
                <div className="modern_card">
                  <h2 className="modern_card_title">
                    <div className="modern_title_accent"></div>
                    Expectations from eKalakaar
                  </h2>
                  <p className="modern_card_text">
                    {formData?.expectations || "No expectations specified."}
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="modern_sidebar">
                
                {/* Contact Card */}
                <div className="modern_card">
                  <h3 className="modern_sidebar_title">Contact Information</h3>
                  <div className="modern_contact_list">
                    <div className="modern_contact_block">
                      <div className="modern_contact_icon_box">
                        <AiOutlineMail className="modern_sidebar_icon" />
                      </div>
                      <div className="modern_contact_info">
                        <p className="modern_contact_label">Email</p>
                        <a href={`mailto:${formData?.contactDetails?.email}`} className="modern_contact_link">
                          {formData?.contactDetails?.email}
                        </a>
                      </div>
                    </div>
                    
                    <div className="modern_contact_block">
                      <div className="modern_contact_icon_box">
                        <AiOutlinePhone className="modern_sidebar_icon" />
                      </div>
                      <div className="modern_contact_info">
                        <p className="modern_contact_label">Phone</p>
                        <a href={`tel:${parseInt(formData?.contactDetails?.contactNumber)}`} className="modern_contact_link">
                          {parseInt(formData?.contactDetails?.contactNumber)}
                        </a>
                      </div>
                    </div>

                    {formData?.contactDetails?.website && (
                      <div className="modern_contact_block">
                        <div className="modern_contact_icon_box">
                          <AiOutlineGlobal className="modern_sidebar_icon" />
                        </div>
                        <div className="modern_contact_info">
                          <p className="modern_contact_label">Website</p>
                          <a 
                            href={`https://${formData?.contactDetails?.website}`} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="modern_contact_link"
                          >
                            {formData?.contactDetails?.website}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Address Card */}
                <div className="modern_card">
                  <h3 className="modern_sidebar_title">Location</h3>
                  <div className="modern_contact_list">
                    <div className="modern_contact_block">
                      <div className="modern_contact_icon_box">
                        <AiOutlineEnvironment className="modern_sidebar_icon" />
                      </div>
                      <div className="modern_contact_info">
                        <p className="modern_location_city">{formData?.address?.city}</p>
                        <p className="modern_location_state">{formData?.address?.state}</p>
                        <p className="modern_location_pin">PIN: {formData?.address?.pincode}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Edit Button */}
                <button 
                  onClick={() => navigate("/Edit_Patron_Portfolio")}
                  className="modern_edit_button"
                >
                  <AiOutlineEdit className="modern_edit_icon" />
                  Edit Portfolio
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}